// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__MjZwh","sub_container":"WordGameLayout_sub_container__oqZrY"};